import { jsxs as d, jsx as r } from "react/jsx-runtime";
import { E as f, S as g } from "./icons.types-0722eef5.js";
function u({ title: i, titleId: n, size: l, width: s, height: e, extended: a = !1, ...t }) {
  const o = a ? f : g, h = l ? o[l] : s || o[a ? "s" : "l"], c = l ? o[l] : e || o[a ? "s" : "l"];
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      width: h,
      height: c,
      "aria-labelledby": n,
      ...t,
      children: [
        i ? /* @__PURE__ */ r("title", { id: n, children: i }) : null,
        /* @__PURE__ */ r(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M16.572.02a3.343 3.343 0 1 1-2.647 5.386L6.651 9.043a3.343 3.343 0 0 1 0 1.914l7.285 3.643a3.343 3.343 0 1 1-.625 1.318L5.936 12.23a3.343 3.343 0 1 1 0-4.462l7.37-3.685A3.343 3.343 0 0 1 16.572.02Zm0 14.75a1.884 1.884 0 1 0 0 3.77 1.884 1.884 0 0 0 0-3.77ZM3.447 8.116a1.884 1.884 0 1 0 0 3.77 1.884 1.884 0 0 0 0-3.77ZM16.572 1.48a1.884 1.884 0 1 0 0 3.769 1.884 1.884 0 0 0 0-3.769Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
export {
  u as Share
};
